/**
   * Given a data as an input, return a boolean
   * Check whether input is a Object
   * Example
   * ===========================
   * isObject({id: 1}) => true
   * ===========================
   * @param {any} data
   * @return {boolean}
   */

export default (data) => typeof data === "object";
